import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Grid from "../../components/grid/grid";
import axios from "axios";
import "./weingut.scss"
import { Helmet } from "react-helmet";
import axiosInstance from "../../api/axiosInstance";

const Weingut = () => {

    const location = useLocation();

    const winerySlug = location.pathname.split("/")[2];

    const [winery, setWinery] = useState([]);
    const [image, setImage] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const accessKey = "bIY5nnkY9lOLNA2my3lODpYq2t6puTD5EDEn5I6V8_0";

    const fetchData = useCallback(async () => {
        try {
            const [wineriesRes, imageRes] = await Promise.all([
                axiosInstance.get(`wineries/${winerySlug}`),
                axios.get(`https://api.unsplash.com/photos/random?query=${winerySlug}&client_id=${accessKey}`)
            ]);
            setWinery(wineriesRes.data);
            setImage(imageRes.data);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, [winerySlug]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return isLoading ? (<div className="loading" />) : (
        <div className="weingut">
            <Helmet>
                <title>{winery.item.weingut} | Weinkeller</title>
            </Helmet>
            <div className="header">
                <div className="container">
                    <h1>{winery.item.weingut}</h1>
                    <p>{(winery.item.region && winery.item.region + ", ") + winery.item.land}</p>
                    <div className="background">
                        <img src={image.urls.regular} alt="Header" />
                    </div>
                    <div className="box">
                        <div className="item">
                            <h3>{winery.item.countWeine}</h3>
                            <span>{winery.item.countWeine > 1 ? "Weine" : "Wein"} aus diesem Weingut</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <Grid
                    wines={winery.data}
                    isLoading={isLoading}
                />
            </div>
        </div>
    )
};

export default Weingut